// Keep the minimum format rule consistent with the claims client's validateEmail.
export function validateEmail(input: string) {
  return /^[a-z0-9!.#$%&'*+/=?^_`{|}~-]+@(?=.{1,255}$)(?:[a-z0-9-]{1,63}\.){1,}(?:[a-z0-9-]{1,63})$/i.test(input);
}
